module.exports = __webpack_public_path__ + "img/ReferralLink.1087662a.svg";